import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-27/task-01";

const task: Slide = {
  titleHtml:
    "Consider a wall with surface impedance Z = (1+i) Zc, where Zc = ρ<sub>0</sub> c is the<br>characteristic impedance of air. Calculate the absorption coefficient α of the surface.",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
